module.exports = __webpack_public_path__ + "static/media/your_book.9105901b.png";